import React, { useState } from 'react';
import Layout from 'components/Layout';
import './miniGoogleLens.scss';

const MiniGoogleLens = () => {
    const [image, setImage] = useState<File | null>(null);
    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const [url, setUrl] = useState<string>('');

    const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleUrlChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUrl(event.target.value);
    };

    const handleSubmit = () => {
        if (image || url) {
            console.log('Image:', image, 'URL:', url);
            //  ajouter la logique pour traiter l'image ou l'URL
            alert('Recherche lancée ! (Fonctionnalité à implémenter)');
        } else {
            alert('Veuillez télécharger une image ou entrer une URL');
        }
    };

    return (
        <div className="mini-google-lens-container">
            <h1>Mini Google Lens</h1>
            
            <div className="upload-section">
                <label htmlFor="image-upload" className="upload-button">
                    📸 Téléversez une image
                </label>
                <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                />
                {imagePreview && (
                    <div className="image-preview">
                        <img src={imagePreview} alt="Aperçu de l'image" />
                    </div>
                )}
            </div>
            
            <div className="url-section">
                <label htmlFor="url-input">🔗 Ou entrez une URL:</label>
                <input
                    id="url-input"
                    type="text"
                    value={url}
                    onChange={handleUrlChange}
                    placeholder="https://example.com"
                />
            </div>
            
            <button className="submit-button" onClick={handleSubmit}>
                🔍 Rechercher avec ID Lens
            </button>
        </div>
    );
};

export default MiniGoogleLens;
